import { createSelector } from 'reselect';

import { applyStoreSelector } from '..';
import { ApplyStateInterface } from './state';

export const getApplication = createSelector(
  applyStoreSelector,
  (store: ApplyStateInterface) => store.application || null
);

export const getError = createSelector(
  applyStoreSelector,
  (store: ApplyStateInterface) => store.error || null
);
